var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-overlay',{model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"128"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }